import { useEffect, useState } from "react"

export const useSchemaFormOutput = (
    initialData: unknown
): [any, (formData: unknown) => void] => {
    const [outputFormData, setOutputFormData] = useState<unknown>(initialData)

    useEffect(
        () => {
            setOutputFormData(initialData)
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [JSON.stringify(initialData)]
    )

    return [outputFormData ?? initialData, setOutputFormData] // it may take time for the initial data to appear, so it may take time for the outputformdata to get updated
}
